import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, Contesto, GraficoTorta, GraficoLimite, CampoData, DashboardProdottiFideAffidamento } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';


interface IFidePolizzaListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPaginePolizza;
    ParamAPIPagine: Dati.CParamAPIPagineAnagrafica;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class FidePolizzaLista extends BaseComponent<Glob.IRouteGlobaleProps, IFidePolizzaListaState> {

    private ParametriFissi: Dati.TListaParametri = {};
    private Grafici: any[] = [];
    private infoContesto: Dati.InfoContesto[] = [];

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagineAnagrafica = new Dati.CParamAPIPagineAnagrafica();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        Param.ID_Anag = (this.props.match.params as any).ID_Anag;
        if ((this.props.match.params as any).ID_FideAffidamento != undefined && (this.props.match.params as any).ID_FideAffidamento != null && (this.props.match.params as any).ID_FideAffidamento != "") {
            this.ParametriFissi["ID_FideAffidamento"] = (this.props.match.params as any).ID_FideAffidamento;
        }
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si pu� scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);

        var M = Glob.GetMenu();
        M.Main = "Affidamento";
        M.ID_MenuMain = 24;
        M.VariabiliMenu = { ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString() };
        this.props.SetMenu(M);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [7,8,9], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_Polizza", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("Polizza", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("DataEffetto", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("DataFine", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("TipoProdotto", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 5:
                                this.OnOrdinamento("TipoRamo", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 6:
                                this.OnOrdinamento("StatoPolizza", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnCaricaUtilizzoPerProdotto(sender: ChiamaAPI, dati: Dati.CRisAPIDizionario<number>): React.ReactNode {
        if (dati.Dati != undefined) {
            let datiGrafico: number[] = [];
            let etichette: string[] = [];
            let coloriDiSfondo: string[] = [];
            let coloriDiSfondoSuSelezione: string[] = [];
            let i: number = -1;
            for (const key of Object.keys(dati.Dati)) {
                i++;
                const value = dati.Dati[key];
                datiGrafico.push(value);
                etichette.push(key);
                coloriDiSfondo.push(Glob.ColoreStatic(i));
                coloriDiSfondoSuSelezione.push("#4189C7");
            }
            return <GraficoTorta Altezza={100} Larghezza={100} Titolo={Trad.Trad("Prodotti emessi")} Dati={datiGrafico} Etichette={etichette} ColoriDiSfondo={coloriDiSfondo} ColoriDiSfondoSuSelezione={coloriDiSfondoSuSelezione} />;
        }
        else
            return false;
    }

    private OnCaricaLimiti(sender: ChiamaAPI, dati: DatiFide.CRisAPIListaLimitiFideAffidamento): React.ReactNode {
        if (dati.Dato != undefined) {
            let datiGrafico: number[] = [];
            let etichette: string[] = [];
            let coloriDiSfondo: string[] = [];
            let coloriDiSfondoSuSelezione: string[] = [];
            datiGrafico.push(dati.Dato.LimiteMassimoContraente - dati.Dato.LimiteMassimoContraenteUtilizzato);
            datiGrafico.push(dati.Dato.LimiteMassimoContraenteUtilizzato);
            etichette.push(Trad.Trad("Limite rimasto"));
            etichette.push(Trad.Trad("Limite utilizzato"));
            coloriDiSfondo.push("#4189C7");
            coloriDiSfondo.push("#EAF4F9");
            coloriDiSfondoSuSelezione.push("#4189C7");
            coloriDiSfondoSuSelezione.push("#EAF4F9");
            return <GraficoLimite Altezza={100} Larghezza={100} Titolo={Trad.Trad("Utilizzo affidamento")} EtichettaConsumato={Trad.Trad("Limite utilizzato")} EtichettaRimanente={Trad.Trad("Limite rimasto")} ValoreConsumato={dati.Dato.LimiteMassimoContraenteUtilizzato} ValoreRimanente={dati.Dato.LimiteMassimoContraente - dati.Dato.LimiteMassimoContraenteUtilizzato} />;
        }
        else {
            return false;
        }
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPaginePolizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={12} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr data-row="0" key={dato.ID_Polizza}>
                        <td data-field="ID" className="TextCenter"> <a href="#" className="arrow" onClick={(e) => { e.preventDefault(); this.props.history.push("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FidePolizza/" + dato.ID_Polizza) }}>
                            {dato.ID_Polizza}
                        </a>
                        </td>
                        <td data-field="Polizza" className="TextLeft">{dato.Polizza}<br/>{dato.Contraente}</td>
                        <td data-field="DataEffetto" className="TextCenter">{Trad.Trad(dato.DataEffetto)}</td>
                        <td data-field="DataFine" className="TextCenter">{Trad.Trad(dato.DataFine)}</td>
                        <td data-field="TipoProdotto" className="TextLeft">{Trad.Trad(dato.TipoProdotto)}</td>
                        <td data-field="TipoRamo" className="TextLeft">{Trad.Trad(dato.TipoRamo)}</td>
                        <td data-field="StatoPolizza" className="TextLeft">{Trad.Trad(dato.StatoPolizza)}</td>
                        <td data-field="DataInizioCopertura" className="TextLeft">{Glob.DataValoreTrad(dato.DataInizioCopertura)}</td>
                        <td data-field="DataFineCopertura" className="TextLeft">{Glob.DataValoreTrad(dato.DataFineCopertura)}</td>
                        <td data-field="edit" className="TextCenter">
                            <a href="#" className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FidePolizza/" + dato.ID_Polizza) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>
                )}
            </tbody>;
        }
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={8}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        if (!this.ControlloAutorizzazione("PolizzaController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        this.infoContesto = [];
        this.Grafici = [];
        this.Grafici.push(<ChiamaAPI Aggiornare={1} URL={"/api/fideaffidamento/GetLimiti?ID_FideAffidamento=" + this.state.Parametri["ID_FideAffidamento"]} OnRis={(s, d) => this.OnCaricaLimiti(s, d)} OnErrore={this.OnErroreLista} />);
        this.Grafici.push(<ChiamaAPI Aggiornare={1} URL={"/api/fideaffidamento/GetUtilizzoPerProdotto?ID_FideAffidamento=" + this.state.Parametri["ID_FideAffidamento"]} OnRis={(s, d) => this.OnCaricaUtilizzoPerProdotto(s, d)} OnErrore={this.OnErroreLista} />);
        //this.Grafici.push(<DashboardProdottiFideAffidamento ID_FideAffidamento={Number(this.state.Parametri["ID_FideAffidamento"])} />);

        this.infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));
        this.infoContesto.push(new Dati.InfoContesto(Trad.Trad("Affidamento"), "/api/FideAffidamento/Contesto?ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento, "/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento));
        this.infoContesto.push(new Dati.InfoContesto(Trad.Trad("Grafici"), "", "#", this.Grafici));
        return <div>
            <Contesto Id="InfoContesto" Info={this.infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-file"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("PolizzePreventivi")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <a href={"/api/polizza/esporta?ID_Anag=" + (this.props.match.params as any).ID_Anag + "&ID_FideAffidamento=" + (this.props.match.params as any).ID_FideAffidamento + "&Sessione=" + Glob.GetSessione().Sessione} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg hidden" title={Trad.Trad("Excel")}>
                                    <i className="fa fa-file-excel"></i>
                                </a>
                                <NavLink to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/FideAffidamento/" + (this.props.match.params as any).ID_FideAffidamento + "/FidePolizza/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_Polizza"] || ""} name="ParametriUtente[ID_Polizza]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Numero Polizza")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <input onChange={(e) => this.OnChange(e)} type="text" value={this.state.ParametriUtente["Polizza"] || ""} name="ParametriUtente[Polizza]" className="form-control kt-input" placeholder={Trad.Trad("Numero Polizza")} />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Data effetto")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={false}
                                        Name="ParametriUtente[DataEffetto]"
                                        Id="ParametriUtente[DataEffetto]"
                                        Valore={this.state.ParametriUtente["DataEffetto"]}
                                        OnChange={this.OnChange} />
                                </div>
                            </div>
                        </div>

                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("TipoProdotto")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo URL={"/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto"} Campo="ParametriUtente[ID_TipoProdotto]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoProdotto"] || ""} OnAggiorna={this.OnChange} />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Data fine")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <div className="form-control">
                                    <CampoData ValoreInArrivo={false}
                                        Name="ParametriUtente[DataFine]"
                                        Id="ParametriUtente[DataFine]"
                                        Valore={this.state.ParametriUtente["DataFine"]}
                                        OnChange={this.OnChange} />
                                </div>
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Stato")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo Campo="ParametriUtente[ID_TipoPolizzaStato]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoPolizzaStato"] || ""} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=PolizzaStato" />
                            </div>
                        </div>


                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                            <div className="row">
                                <div className="col col kt-form__actions kt-form__actions--center">
                                    <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
                <div>
                    <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                        <thead>
                            <tr className="sfondoTab">
                                <th scope="row" className="TextCenter">ID</th>
                                <th data-field="Polizza" className="TextLeft">{Trad.Trad("Polizza")}</th>
                                <th data-field="DataEffetto" className="TextCenter">{Trad.Trad("Data effetto")}</th>
                                <th data-field="DataFine" className="TextCenter">{Trad.Trad("Data fine")}</th>
                                <th data-field="TipoProdotto" className="TextLeft">{Trad.Trad("TipoProdotto")}</th>
                                <th data-field="TipoRamo" className="TextLeft">{Trad.Trad("TipoRamo")}</th>
                                <th data-field="StatoPolizza" className="TextLeft">{Trad.Trad("Stato")}</th>
                                <th data-field="StatoPolizza" className="TextLeft">{Trad.Trad("DataInizioCopertura")}</th>
                                <th data-field="StatoPolizza" className="TextLeft">{Trad.Trad("DataFineCopertura")}</th>
                                <th data-field="edit" className="TextCenter">{Trad.Trad("Modifica")}</th>
                            </tr>
                        </thead>
                        <ChiamaAPI Aggiornare={this.state.Aggiornare} Metodo="POST" URL="/api/Polizza/Ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                    </table>
                </div>
                <div className="row">
                    <div className="col-lg-11"></div>
                    <div className="col-lg-1">
                        
                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/FidePolizzaLista.tsx